import React from 'react';
import { mfaManagementRoute as route } from 'routes/constants';

const RouteComponent = React.lazy(() => import('./MfaManagementPage'));

export default {
  RouteComponent,
  path: route,
};
